import { styled } from "@mui/material";

interface FilledColoredCircleProps {
  color: string;
  size?: number;
}

export const FilledColoredCircle = styled("div")<FilledColoredCircleProps>`
  width: ${({ size = 12 }) => `${size}px`};
  height: ${({ size = 12 }) => `${size}px`};
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;
